module.exports = __webpack_public_path__ + "img/pexels-cedric-fauntleroy-4269694.51390238.jpg";